require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 237
// module chunks = 1